import { GridColumns, GridComparatorFn, GridRenderCellParams, gridStringOrNumberComparator, gridDateComparator, GridValueGetterParams, GridValueFormatterParams } from "@mui/x-data-grid-pro";
import { ITranslationManager } from "@fenetech/translations";
import { IApplicationInfo, IDashboardOrder } from "helpers/interfaces";
import { Theme, Typography } from "@mui/material";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import { IRecordWithReqDate } from "models/IDashboardOrder";
import { ICurrencyFormatter } from "helpers/hooks/useCurrencyFormatter";
import ApiUser from "models/ApiUser";
import Format from "helpers/fv.format";

export const generateOrderColumns = (tm: ITranslationManager, data: IDashboardOrder[] | null, theme: Theme, application: IApplicationInfo, isMobile: boolean, cf: ICurrencyFormatter, user: ApiUser) => {

    if (!data || data.length === 0) return [] as GridColumns;

    let reqDateColumnHeader: string = tm.Get("Est Delivery Date");
    if (application && application.parameters.customDeliveryDateLabel) {
        reqDateColumnHeader = application.parameters.customDeliveryDateLabel;
    }

    const generator = new DataGridColumnGenerator(tm, data, theme, isMobile, cf);

    generator.TryAddDocumentNumberColumn("oKey", "orderNumber", "Order", "/orders", { hideable: false });
    generator.TryAddDateColumn("orderDate", "Date", {});
    generator.TryAddTextColumn("poNumber", "PO Number", {});
    generator.TryAddTextColumn("customerRef", "Customer Ref", {});
    generator.TryAddTotalPriceColumn({});

    generator.AddColumn({
        field: "reqDate",
        headerName: reqDateColumnHeader,
        minWidth: generator.GetMinWidth(),
        flex: 1,
        sortComparator: reqDateSortComparator,
        valueGetter: (params: GridValueGetterParams) => ({
            reqDate: params.row.reqDate,
            reqDateString: params.row.reqDateString
        }),
        valueFormatter: (params: GridValueFormatterParams) => {
            const reqDate = params.value.reqDate;
            const reqDateString = params.value.reqDateString;

            if (reqDate) {
                return Format.FormatDate(reqDate as string);
            } else {
                return reqDateString;
            }
        },
        renderCell: (params: GridRenderCellParams<any, IRecordWithReqDate>) => {
            return <>
                <Typography variant="body2">
                    {params.formattedValue}
                </Typography>
            </>;
        }
    });

    generator.TryAddDateColumn("targetShipDate", "Target Ship Date", {});

    generator.TryAddStatusColumn();
    if (user.isMultiSite) {
        generator.TryAddTextColumn("mfgSiteName", "Mfg Customer", {});
    }

    return generator.GetColumns();
}

const reqDateSortComparator: GridComparatorFn = (v1, v2, param1, param2) => {
    if (v1.reqDate && v2.reqDate) {
        return gridDateComparator(v1.reqDate, v2.reqDate, param1, param2);
    }

    if (v1.reqDate) {
        return -1; // Req dates come before req date strings
    }

    if (v2.reqDate) {
        return 1
    }

    return gridStringOrNumberComparator(v1.reqDateString, v2.reqDateString, param1, param2);
}